import '@popperjs/core';
import jquery
    from 'jquery';
import aos
    from "aos";

import GLightbox from "glightbox";
import Swiper from 'swiper';
import {Navigation, Pagination, Autoplay} from 'swiper';
import 'lite-youtube-embed';

window.jQuery = jquery;
window.$ = jquery;
import {
    Modal
} from 'bootstrap';


$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    },
    cache: true
});

$.fn.isVisible = function () {
    let elementTop = $(this).offset().top;
    let elementBottom = elementTop + $(this).outerHeight();
    let viewportTop = $(window).scrollTop();
    let viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
};

let utility = {
    scroll: function (e) {
        $('html').animate({
            scrollTop: (e.offset().top - 100)
        }, "slow");
    }
}

$(function () {
    "use strict";

    /**
     * Apply .scrolled class to the body as the page is scrolled down
     */
    function toggleScrolled() {
        const selectBody = document.querySelector('body');
        const selectHeader = document.querySelector('#header');
        if (!selectHeader.classList.contains('scroll-up-sticky') && !selectHeader.classList.contains('sticky-top') && !selectHeader.classList.contains('fixed-top')) return;
        window.scrollY > 100 ? selectBody.classList.add('scrolled') : selectBody.classList.remove('scrolled');
    }

    document.addEventListener('scroll', toggleScrolled);
    window.addEventListener('load', toggleScrolled);

    /**
     * Mobile nav toggle
     */
    const mobileNavToggleBtn = document.querySelector('.mobile-nav-toggle');

    function mobileNavToogle() {
        document.querySelector('body').classList.toggle('mobile-nav-active');
        mobileNavToggleBtn.classList.toggle('bi-list');
        mobileNavToggleBtn.classList.toggle('bi-x');
    }

    if (mobileNavToggleBtn) {
        mobileNavToggleBtn.addEventListener('click', mobileNavToogle);
    }

    /**
     * Hide mobile nav on same-page/hash links
     */
    document.querySelectorAll('#navmenu a').forEach(navmenu => {
        navmenu.addEventListener('click', () => {
            if (document.querySelector('.mobile-nav-active')) {
                mobileNavToogle();
            }
        });

    });

    /**
     * Toggle mobile nav dropdowns
     */
    document.querySelectorAll('.navmenu .toggle-dropdown').forEach(navmenu => {
        navmenu.addEventListener('click', function (e) {
            e.preventDefault();
            this.parentNode.classList.toggle('active');
            this.parentNode.nextElementSibling.classList.toggle('dropdown-active');
            e.stopImmediatePropagation();
        });
    });

    /**
     * Preloader
     */
    $('#preloader').remove();

    /**
     * Scroll top button
     */
    let scrollTop = document.querySelector('.scroll-top');

    function toggleScrollTop() {
        if (scrollTop) {
            window.scrollY > 100 ? scrollTop.classList.add('active') : scrollTop.classList.remove('active');
        }
    }

    scrollTop.addEventListener('click', (e) => {
        e.preventDefault();
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    });

    window.addEventListener('load', toggleScrollTop);
    document.addEventListener('scroll', toggleScrollTop);

    /**
     * Animation on scroll function and init
     */
    function aosInit() {
        aos.init({
            duration: 600,
            easing: 'ease-in-out',
            once: true,
            mirror: false
        });
    }

    window.addEventListener('load', aosInit);

    /**
     * Init swiper sliders
     */
    function initSwiper() {
        document.querySelectorAll(".init-swiper").forEach(function (swiperElement) {
            let config = JSON.parse(
                swiperElement.querySelector(".swiper-config").innerHTML.trim()
            );

            if (swiperElement.classList.contains("swiper-tab")) {
                initSwiperWithCustomPagination(swiperElement, config);
            }
            else {
                new Swiper(swiperElement, config);
            }
        });
    }

    window.addEventListener("load", initSwiper);

    /**
     * Initiate glightbox
     */
    const glightbox = GLightbox({
        selector: '.glightbox'
    });

    const sections = document.querySelectorAll('.blog-details h2[id]');
    const navLinks = document.querySelectorAll('.toc-nav a[href^="#"]');
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                const id = entry.target.id;
                navLinks.forEach((link) => {
                    link.classList.toggle(
                        'active',
                        link.getAttribute('href') === `#${id}`
                    );
                });
            });
        },
        {
            rootMargin: '-20% 0px -70% 0px',
            threshold: 0
        }
    );
    sections.forEach((section) => observer.observe(section));
    $('.glossary-reset > a').on('click', function (e) {
        e.preventDefault();
        $.when($('.glossary-term').show()).done(function () {
            utility.scroll($('.glossary-term'));
        });
        return false;
    });
    $('.glossary-letter').on('click', function (e) {
        e.preventDefault();
        let letter = $(this).attr('data-letter');
        $('.glossary-term').hide();
        $.when($('.term-' + letter).show()).done(function () {
            utility.scroll($('.term-' + letter));
        });
        return false;
    });

    let form = document.getElementById('RoiCalculatorForm');
    if (form.length > 0) {
        form.addEventListener('submit', function (event) {
            event.preventDefault();
            if (form.checkValidity() === false) {
                utility.scroll($('.form-control:invalid, .form-check-input:invalid, .form-select:invalid').eq(0));
                event.stopPropagation();
            }
            else {
                $.ajax('', {
                    type: 'POST',
                    dataType: 'JSON',
                    data: $('#RoiCalculatorForm').serialize()
                }).done(function (Response) {
                    let Data = Response.Data.Results;
                    $('#CurrentLeads').html(Data.currentLeads.toLocaleString());
                    $('#OptimizedLeads').html(Data.optimizedLeads.toLocaleString());
                    $('#DifferenceLeads').html(Data.differenceLeads.toLocaleString());
                    $('#CurrentRevenue').html(Data.currentRevenue.toLocaleString());
                    $('#OptimizedRevenue').html(Data.optmizedRevenue > 0 ? Data.optmizedRevenue.toLocaleString() : Data.optmizedRevenue);
                    $('#RevenueLift').html(Data.revenueLift.toLocaleString());
                });
            }
            form.classList.add('was-validated');
        }, false);
    }
});